export interface StatusOptions {
    code: number
    name: string
}

export const statuses = {
    BLANK: { code: 0, name: 'blank' },
    LOADED: { code: 100, name: 'loaded' },
    SHOWN: { code: 150, name: 'shown' },
    READY: { code: 200, name: 'ready' },
    STOPPED: { code: 250, name: 'stopped' },
    PAUSED: { code: 275, name: 'paused' },
    STARTED: { code: 300, name: 'started' },
}
